export const environment = {
  production: true,
  buildId: '2511037777817391',
  configFile: 'config.json',
};
